import type { SVGProps } from 'react';

export function HouseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 14h-2a2 2 0 0 0-2 2v5a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3V9.982a3 3 0 0 1 1.05-2.28l7-5.985a3 3 0 0 1 3.9 0l7 5.985A3 3 0 0 1 22 9.982V19a3 3 0 0 1-3 3h-3a1 1 0 0 1-1-1v-5a2 2 0 0 0-2-2" />
    </svg>
  );
}
